/**
 * Форматирует дату в формат "день месяц" (например, "27 сентября")
 */
export function formatDayMonth (date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' })
}
